import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { useBusinessAuthContext } from "./useBusinessAuthContext";
import LocationForm from "../businesslocations/LocationForm";
import API_URL from "../../api/API";

const LocationCreateForm = () => {
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();
  const { waiverId } = useParams();

  const [states, setStates] = useState([]);

  const [form, setForm] = useState({
    name: "",
    street: "",
    city: "",
    state: "",
    zip: "",
  });

  useEffect(() => {
    const fetchStates = async () => {
      const res = await fetch(API_URL.BUSINESS_STATE_LIST, {
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,            
            "x-frontend-url": window.location.pathname
          },
        });
      const data = await res.json();
      if (data.success) {
        setStates(data.states);
      }
    };

    fetchStates();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    const res = await fetch(API_URL.BUSINESS_ADD_LOCATION, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${business.token}`,
        "x-session-id": business.sessionId,            
        "x-frontend-url": window.location.pathname
      },
      body: JSON.stringify(form),
    });

    const data = await res.json();

    if (data.success) {
      navigate(
        `/business/waiverbuilder/smart/${waiverId}/step-2?new=${data.location._id}`
        /* Then in Step-2, read the query param 'new' and pre-check that checkbox.*/
      );
    } else {
      alert(data.message);
    }
  };

  return (
    <div className="h-screen flex bg-background">
      <Sidebar />

      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">

          <button
            onClick={() =>
              navigate(`/business/waiverbuilder/smart/${waiverId}/step-2?from=back`)
            }
            className="text-sm text-muted-foreground mb-4"
          >
            ← Back to Builder
          </button>

          <h2 className="text-xl font-semibold mb-6">
            Add a location to publish this waiver
          </h2>

          <LocationForm
            onSuccess={(loc) => {
              navigate(
                `/business/waiverbuilder/smart/${waiverId}/step-2?new=${loc._id}`
              );
            }}
          />

          { /* <input
            name="name"
            placeholder="Location Name"
            onChange={handleChange}
            className="w-full border p-3 rounded mb-3"
          />

          <input
            name="street"
            placeholder="Street"
            onChange={handleChange}
            className="w-full border p-3 rounded mb-3"
          />

          <input
            name="city"
            placeholder="City"
            onChange={handleChange}
            className="w-full border p-3 rounded mb-3"
          />

          <select
            name="state"
            value={form.state}
            onChange={handleChange}
            className="w-full border p-3 rounded mb-3"
          >
            <option value="">Select State</option>
            {states.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>

          <input
            name="zip"
            placeholder="Zip Code"
            onChange={handleChange}
            className="w-full border p-3 rounded mb-6"
          />

          <button
            onClick={handleSave}
            className="w-full bg-yellow-500 rounded-full py-3 font-medium"
          >
            Save Location & Continue →
          </button> */ }

        </div>
      </div>
    </div>
  );
};

export default LocationCreateForm;